import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import Home from './Page/Home';
import Login from './Page/Login';
import MinhaCarteira from './Page/MinhaCarteira'; 
import Painel from './Page/Painel';
import NotifyComp from './components/Notify';
import Cursos from './Page/Cursos';
import Aula from './Page/Aula';
import Validacao from './Page/Validacao'; 
import Certificado from './Page/Certificado'; 
import ValidarMinhaCarteira from './Page/ValidarMinhaCarteira';
import VisualizarMinhaCarteira from './Page/ValidarMinhaCarteira/VisualizarMinhaCarteira';
import PrivateRoute from './PrivateRoute'; 
import NotFound from './Page/NotFound';
import PoliticaDePrivacidade from './Page/Termos/PoliticaDePrivacidade';
import TermosDeUso from './Page/Termos/TermosDeUso';

const router = createBrowserRouter([
  {
    path: "/",
    element: <Home />,
    errorElement: <NotFound />
  },
  {
    path: "/politica-de-privacidade",
    element: <PoliticaDePrivacidade />,
    errorElement: <NotFound />
  },
  {
    path: "/termos-de-uso",
    element: <TermosDeUso />,
    errorElement: <NotFound />
  },
  {
    path: "/login",
    element: <Login />,
    errorElement: <NotFound />
  },
  {
    path: "/carteiraVisualizar",
    element: <PrivateRoute element={<MinhaCarteira />} /> ,
    errorElement: <NotFound />
  },
  
  
  
  {
    path: "/cursos/:id",
    element: <PrivateRoute element={<Cursos />} /> ,
    errorElement: <NotFound />
  },
  {
    path: "/aula",
    element: <PrivateRoute element={<Aula />} /> ,
    errorElement: <NotFound />
  },
  {
    path: "/validar/:email",
    element: <Validacao />,
    errorElement: <NotFound />
  },
  {
    path: "/certificado/:email",
    element: <Certificado />,
    errorElement: <NotFound />
  },
  {
    path: "/validar",
    element: <Validacao />,
    errorElement: <NotFound />
  },
  {
    path: "/certificado",
    element: <Certificado />,
    errorElement: <NotFound />
  },
  /* {
    path: "/registrar/",
    element: <Register />,
  }, */
  {
    path: "/painel",
    element: <PrivateRoute acess={['ESTUDANTE']} element={<Painel />} /> ,
    errorElement: <NotFound />
  },
  {
    path: "/minhacarteira",
    element: <PrivateRoute acess={['ESTUDANTE']} element={<ValidarMinhaCarteira />} />,
    errorElement: <NotFound />
  },
  {
    path: "/visualizaminhacarteira",
    element:  <PrivateRoute acess={['ESTUDANTE']} element={<VisualizarMinhaCarteira />} />,
    errorElement: <NotFound />
  },




  
]);
/* ADMINISTRADOR, FUNCIONARIO, ESTUDANTE */
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <NotifyComp />
    <RouterProvider router={router} />
  </React.StrictMode>
);
 
